<div class="w-100 d-flex" [class.flex-row-reverse]="isRTL">

    <div class="position-absolute w-100 d-flex zx-z-index-2" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeLoginDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- video -->
    <div *ngIf="!isIphone()" class="zx-login-video-container position-relative overflow-hidden">
        <img src="../../../assets/images/eazix-logo-white.svg" alt="Eazix Logo"
            class="zx-logo-white svg position-absolute zx-z-index-2" [class.zx-logo-white-rtl]="isRTL">
        <video alt="Plotter Video" class="object-fit-contain zx-z-index-1" muted autoplay loop>
            <source src="../../../assets/videos/login-video.mp4" type="video/mp4">
        </video>
        <div class="position-absolute w-100 h-100">
            <img src="/assets/images/login-video-first-frame.jpg" class="w-100 h-100 object-fit-contain"
                alt="Plotter Image">
        </div>
    </div>

    <!-- login signup -->
    <div *ngIf="loginStage === 0"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-prelogin-title" | translate }}
        </h4>
        <p class="m-0 px-2 text-center" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-prelogin-explanation" | translate }}
        </p>
        <span class="spacer"></span>

        <button mat-stroked-button class="mat-stroked-button w-100" [class.mat-stroked-button-dark-mode]="isDarkMode"
            role="button" tabindex=-1 (click)="signInWithGoogle()">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <img class="zx-icon-log-in" src="../../../assets/images/google-icon.svg" alt="Google Logo">
                <h5 class="zx-text-medium zx-text-sm-big m-0 align-items-center d-flex" [class.zx-ltr]="isRTL">
                    {{ "log-in-dialog-prelogin-with-google" | translate }}
                </h5>
                <div class="zx-icon-log-in"></div>
            </div>
        </button>

        <!--      <asl-google-signin-button type='standard' size='large' shape="pill" text="continue_with" theme="outline" logo_alignment="center" width="300"></asl-google-signin-button>-->

        <button mat-stroked-button class="mat-stroked-button w-100" [class.mat-stroked-button-dark-mode]="isDarkMode"
            role="button" tabindex=-1 (click)="signInWithFB()">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <img class="zx-icon-log-in" src="../../../assets/images/fb-icon.svg" alt="Facebook Logo">
                <h5 class="zx-text-medium zx-text-sm-big m-0 align-items-center d-flex" [class.zx-ltr]="isRTL">
                    {{ "log-in-dialog-prelogin-with-fb" | translate }}
                </h5>
                <div class="zx-icon-log-in"></div>
            </div>
        </button>

        <button mat-stroked-button class="mat-stroked-button w-100" [class.mat-stroked-button-dark-mode]="isDarkMode"
            role="button" tabindex=-1 (click)="toLoginStage(1)">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <img class="zx-icon-log-in" src="../../../assets/images/mail-icon.svg" alt="Email Logo">
                <h5 class="zx-text-medium zx-text-sm-big m-0 align-items-center d-flex">
                    {{ "log-in-dialog-prelogin-with-mail" | translate }}
                </h5>
                <div class="zx-icon-log-in"></div>
            </div>
        </button>

        <span class="spacer"></span>
        <p class="zx-p-container mb-0 text-center" [class.zx-ltr]="!isRTL">
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-1" | translate }}
            </span>
            <span *ngIf="selectedLanguage !== 'he'" class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="goToTandC()">
                {{ "log-in-dialog-prelogin-t-and-c-tandc" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-2" | translate }}
            </span>
            <span *ngIf="isRTL" class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="goToPP()">
                {{ "log-in-dialog-prelogin-t-and-c-pp" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-3" | translate }}
            </span>
        </p>
    </div>

    <!-- enter mail -->
    <div *ngIf="loginStage === 1"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-withmail-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-text-medium w-100" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            {{ "log-in-dialog-withmail-explanation" | translate }}
        </p>
        <div class="flex-grow-1 d-flex flex-column w-100" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (submit)="onEnterMail(enterMailForm)" #enterMailForm="ngForm"
                *ngIf="!isLoading">
                <span class="spacer"></span>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="email" ngModel type="email" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        [placeholder]="'log-in-dialog-withmail-email' | translate" #emailInput="ngModel" required email>
                    <mat-error *ngIf="emailInput.invalid" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
                    </mat-error>
                </mat-form-field>
                <span class="spacer"></span>
                <div class="d-flex justify-content-center w-100 pt-3">
                    <button mat-raised-button color="primary" type="submit"
                        [disabled]="!emailInput.value || emailInput.value === ''"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- mail exist (ENTER YOUR PASSWORD) -->
    <div *ngIf="loginStage === 2"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">

        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-mailexist-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-p-container" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-1" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="fw-bold zx-text-medium">
                {{email}}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-2" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(1)">
                {{ "log-in-dialog-mailexist-back-to-mail" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-3" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(4)">
                {{ "log-in-dialog-mailexist-reset-password" | translate }}
            </span>
            <span class="zx-text-medium">.</span>
        </p>
        <div class="d-flex flex-column w-100 flex-grow-1" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (submit)="onLoginMail(enterPasswordForm)"
                #enterPasswordForm="ngForm" *ngIf="!isLoading">
                <span class="spacer"></span>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'" type="{{ loginHidePassword ? 'password' : 'text' }}"
                        matInput name="password" ngModel type="password"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #passwordInput="ngModel" required
                        password>
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="toggleLoginPasswordVisibility()">
                        <mat-icon>{{ loginHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passwordInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                    </mat-error>
                </mat-form-field>
                <span class="spacer"></span>
                <div class="d-flex justify-content-center w-100 pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading"
                        [disabled]="!passwordInput.value || passwordInput.value === ''"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- mail NOT exist (CREATE A PASSWORD) -->
    <div *ngIf="loginStage === 3"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-mailnotexist-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-p-container" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailnotexist-explanation-1" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="fw-bold zx-text-medium">
                {{email}}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-2" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(1)">
                {{ "log-in-dialog-mailexist-back-to-mail" | translate }}
            </span>
            <span class="zx-text-medium">.</span>
        </p>
        <div class="d-flex flex-column w-100 flex-grow-1" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (submit)="onSignupMail(enterPasswordForm)"
                #enterPasswordForm="ngForm" *ngIf="!isLoading">
                <div class="d-flex flex-column justify-content-end flex-grow-1 zx-text-small">
                    <span class="px-2 pb-3">
                        {{ "log-in-dialog-mailexist-password-instructions" | translate }}
                    </span>
                </div>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="password" ngModel type="password" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ signupHidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #passwordInput="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="toggleSignupPasswordVisibility()">
                        <mat-icon>{{ signupHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passwordInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="passwordInput.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="passwordInput.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="passwordInput.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>
                <span class="spacer"></span>
                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading" [disabled]="!passwordInput.value || passwordInput.value === '' ||
                        passwordInput.hasError('required') ||
                        passwordInput.hasError('minlength') ||
                        passwordInput.hasError('pattern')" class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
            </form>

        </div>
    </div>

    <!-- RESET PASSWORD -->
    <div *ngIf="loginStage === 4"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">

        <!-- LOADER -->
        <div *ngIf="isLoading" class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <!-- // LOADER -->

        <!-- title -->
        <div *ngIf="!isLoading" class="d-flex flex-column justify-content-center w-100 gap-1">
            <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-reset-password.title" | translate }}
            </h4>
            <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
                <b *ngIf="email.length > 18 && isRTL">
                    ...
                </b>
                <b>
                    {{ email | slice:0:18 }}
                </b>
                <b *ngIf="email.length > 18 && !isRTL">
                    ...
                </b>
            </h4>
        </div>
        <!-- // title -->

        <!-- BEFORE checking pass reset code -->
        <div *ngIf="isPassResetCodeSentToCheck && !isPassResetCodeCorrect && !isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">

            <span [class.text-white]="isDarkMode">
                <span>
                    {{ "log-in-dialog-reset-password.explain-1" | translate }}
                </span>
                <span>
                    <b *ngIf="email.length > 18 && isRTL">
                        ...
                    </b>
                    <b>
                        {{ email | slice:0:18 }}
                    </b>
                    <b *ngIf="email.length > 18 && !isRTL">
                        ...
                    </b>
                </span>
                <span>
                    {{ "log-in-dialog-reset-password.explain-2" | translate }}
                </span>
            </span>

            <span class="spacer"></span>

            <form class="w-100 d-flex flex-column flex-grow-1" #form="ngForm"
                (ngSubmit)="submitPassResetCode(passResetCode)">
                <mat-form-field class="px-4 py-2 w-100" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="passResetCode" [(ngModel)]="passResetCode" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetCodeHidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-reset-password.code-in-email' | translate"
                        #passResetCodeInput="ngModel" required maxlength="10" minlength="10" class="w-100">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetCodeVisibility()">
                        <mat-icon>{{ passResetCodeHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passResetCodeInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="passResetCodeInput.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-reset-password.not-valid" | translate }}
                        </span>
                        <span *ngIf="passResetCodeInput.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-reset-password.not-valid-minlength" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>

                <span class="spacer"></span>

                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading" [disabled]="!form.valid"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "error-content-ok-btn" | translate }}
                    </button>
                </div>
            </form>
        </div>
        <!-- // BEFORE checking pass reset code -->

        <!-- AFTER checking pass reset code -->
        <div *ngIf="!isPassResetCodeSentToCheck && isPassResetCodeCorrect && !isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <span class="spacer"></span>

            <form class="w-100 d-flex flex-column flex-grow-1" #form="ngForm"
                (ngSubmit)="resetPassword(newPass1, newPass2)">

                <span>סיסמה</span>

                <!-- Password Field 1 -->
                <mat-form-field class="w-100 px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="newPass1" [(ngModel)]="newPass1" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetNewCode1HidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #newPass1Input="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetNewCode1Visibility()">
                        <mat-icon>{{ passResetNewCode1HidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="newPass1Input.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="newPass1Input.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="newPass1Input.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="newPass1Input.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>

                <span class="spacer"></span>

                <span>אימות סיסמה</span>

                <!-- Password Field 2 -->
                <mat-form-field class="w-100 px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">

                    <input matInput name="newPass2" [(ngModel)]="newPass2" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetNewCode2HidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #newPass2Input="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetNewCode2Visibility()">
                        <mat-icon>{{ passResetNewCode2HidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="newPass2Input.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="newPass2Input.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="newPass2Input.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>

                </mat-form-field>

                <span class="spacer"></span>

                <div *ngIf="newPass1Input.valid && newPass2Input.valid && newPass1 !== newPass2"
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'" class="zx-text-tiny text-red px-2">
                    {{ "log-in-dialog-mailexist-password-not-match" | translate }}
                </div>

                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading"
                        [disabled]="!form.valid || newPass1 !== newPass2" class="text-white rounded-pill zx-btn-single">
                        {{ "error-content-ok-btn" | translate }}
                    </button>
                </div>
            </form>

        </div>
        <!-- // AFTER checking pass reset code -->

        <!-- sucsessfully reseted -->
        <div *ngIf="isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <h2>
                {{ "log-in-dialog-reset-password.success" | translate }}
            </h2>
        </div>
        <!-- // sucsessfully reseted -->

    </div>

</div>